import { getHasMicroOffer } from '@helpers/FormalOffers/getHasMicroOffer';
import { fetchGetFormalOffers } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../iwQueryClient/useStateKey';
import { FormalOffers } from '../MyOffers.types';

type TApprovedViewData = {
    isLoading: boolean;
    isError: boolean;
    hasSuitabilityOffer: boolean;
    hasMicroOffer: boolean;
    formalOffers: FormalOffers;
};

export const useGetApprovedViewData = (): Partial<TApprovedViewData> => {
    const stateKey = useStateKey();

    const {
        isLoading,
        isError,
        data: formalOffers
    } = useQuery({
        queryKey: ['formal_offers', stateKey],
        queryFn: () => fetchGetFormalOffers({ stateKey })
    });
    if (!formalOffers?.data.formal_offers) {
        return {
            isLoading: isLoading,
            isError: isError
        };
    } else {
        const hasSuitabilityOffer = Boolean(
            formalOffers?.data.formal_offers.length > 1 &&
            formalOffers?.data?.formal_offers[0].suitability_info
        );

        return {
            isLoading: isLoading,
            isError: isError,
            hasSuitabilityOffer: hasSuitabilityOffer,
            hasMicroOffer: getHasMicroOffer(formalOffers.data.formal_offers),
            formalOffers: formalOffers.data.formal_offers
        };
    }
};
